export default __webpack_public_path__ + "static/media/join.55b13e30.mp3";